import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Button, Input } from 'reactstrap';
import * as actions from '../../../actions';
import * as actionsTs from '../../../modules/actions';
import { getTranslationKey } from '../../../modules/utils/helpers';
import type { Notify } from '../../../typings/redux';

interface AvailableRules {
  brandsLeft?: number;
}

interface NewBrandProps {
  disableBrandsCreation?: boolean;
  onUserBrandCreated?: (id: string) => void;
  createUserBrand: (data: { name: string }, notify: Notify) => Promise<string>;
  notify: Notify;
  setUpgradeAccountOpenState: (data: any) => void;
  availableRules?: AvailableRules;
  children?: React.ReactNode;
}

interface NewBrandState {
  isOpen: boolean;
  name: string;
  creating?: boolean;
}

class NewBrand extends Component<NewBrandProps, NewBrandState> {
  constructor(props: NewBrandProps) {
    super(props);

    this.state = {
      isOpen: false,
      name: ''
    };

    this.toggle = this.toggle.bind(this);
    this.create = this.create.bind(this);
  }

  toggle() {
    const { setUpgradeAccountOpenState, availableRules = {} } = this.props;
    const isLimitExceeded = availableRules.brandsLeft === 0;

    if (isLimitExceeded) {
      return setUpgradeAccountOpenState({
        key: 'upgradeModal',
        state: true,
        desiredAction: 'brands',
        modalData: { addon: 'brands' }
      });
    }

    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  }

  async create() {
    this.setState({ creating: true });

    const { createUserBrand, notify, onUserBrandCreated } = this.props;
    const userBrandId = await createUserBrand({ name: this.state.name }, notify);

    if (userBrandId && onUserBrandCreated) {
      this.setState({ isOpen: false, name: '' }, () => onUserBrandCreated(userBrandId));
    }

    this.setState({ creating: false });
  }

  render() {
    const { isOpen, name, creating } = this.state;
    const { disableBrandsCreation } = this.props;

    return (
      <div className="inline">
        <div onClick={disableBrandsCreation ? undefined : this.toggle}>{this.props.children}</div>
        {isOpen && (
          <Modal
            centered
            isOpen={isOpen}
            toggle={this.toggle}
            wrapClassName="modal-dark"
            size="sm"
            backdrop
          >
            <ModalHeader toggle={this.toggle}>{getTranslationKey('userBrand.add')}</ModalHeader>
            <ModalBody>
              <small>
                <b>{getTranslationKey('userBrand.name')}</b>
              </small>
              <Input
                className="mb-2 mt-2"
                value={name}
                type="text"
                onChange={({ target: { value } }) => this.setState({ name: value })}
                placeholder={getTranslationKey('userBrand.namePlaceholder')}
              />
              <Button
                color="primary"
                className="w-100-p"
                disabled={!name || creating}
                onClick={this.create}
              >
                {getTranslationKey('userBrand.add')}
              </Button>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

interface StateProps {
  notify: Notify;
  accessRules: {
    availableRules: AvailableRules;
  };
}

function mapStateToProps({ notify, accessRules: { availableRules } }: StateProps) {
  return { notify, availableRules };
}
export default connect(mapStateToProps, { ...actions, ...actionsTs })(NewBrand);
